/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Muhammad Usman",
  title: "Hi all, I'm Usman",
  subTitle: emoji(
    "Senior Backend Engineer 🚀 with 8+ years architecting scalable, high-performance systems using Node.js, NestJS, Python, FastAPI, and Go. Expert in microservices, AI/GenAI integration, observability stack, and cloud infrastructure on AWS."
  ),
  resumeLink:
    "./Muhammad Usman Resume BE.pdf", // Updated to use Backend-focused resume
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Muhammad-Usman17",
  linkedin: "https://www.linkedin.com/in/muhammad-usman17/",
  gmail: "muhammadusman01501@gmail.com",
  gitlab: "https://gitlab.com/Muhammad-Usman17",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "BACKEND-FOCUSED FULL STACK ENGINEER WITH AI/GENAI EXPERTISE",
  skills: [
    emoji(
      "⚡ Architect and build robust, scalable Backend APIs and microservices using Python (FastAPI), Golang, NestJS, and Node.js"
    ),
    emoji("⚡ Develop AI-powered applications with GenAI, LLMs, LangChain, and intelligent automation workflows"),
    emoji(
      "⚡ Create full-stack solutions with React, Next.js while specializing in Backend architecture and performance optimization"
    ),
    emoji(
      "⚡ Design cloud infrastructure, observability stacks (Prometheus, Grafana, OpenTelemetry), and DevOps pipelines"
    ),
    emoji(
      "⚡ Lead cross-functional teams delivering enterprise-grade systems with modern tech stacks and best practices"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "fas fa-rocket"
    },
    {
      skillName: "golang",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "NestJS",
      fontAwesomeClassname: "fas fa-layer-group"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "fas fa-arrows-alt"
    },
    {
      skillName: "GraphQL",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "gRPC",
      fontAwesomeClassname: "fas fa-exchange-alt"
    },
    {
      skillName: "LangChain",
      fontAwesomeClassname: "fas fa-link"
    },
    {
      skillName: "AutoGen",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "LLM/AI",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "RAG",
      fontAwesomeClassname: "fas fa-search"
    },
    {
      skillName: "Prometheus",
      fontAwesomeClassname: "fas fa-chart-line"
    },
    {
      skillName: "Grafana",
      fontAwesomeClassname: "fas fa-chart-bar"
    },
    {
      skillName: "OpenTelemetry",
      fontAwesomeClassname: "fas fa-satellite-dish"
    },
    {
      skillName: "Loki",
      fontAwesomeClassname: "fas fa-file-alt"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-elephant"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Redis",
      fontAwesomeClassname: "fas fa-memory"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-dharmachakra"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fas fa-cogs"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Bahria University",
      logo: require("./assets/images/bahriaLogo2.png"),
      subHeader: "Bachelor of Software Engineering",
      duration: "September 2013 - April 2017",
      desc: "Graduated with distinction and strong foundation in software engineering principles.",
      descBullets: [
        "Member of Rector Honor List for academic excellence",
        "Open House 2017 Award Winner for outstanding project presentation",
        "Completed comprehensive coursework in Data Structures, Algorithms, Software Architecture, and Database Management",
        "Participated in various programming competitions and hackathons"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend/APIs", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "AI/GenAI",
      progressPercentage: "85%"
    },
    {
      Stack: "DevOps/Infrastructure",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "95%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Lead Software Engineer",
      company: "Emumba",
      companylogo: require("./assets/images/emumbaLogoWhite.png"),
      date: "July 2023 – Present",
      descBullets: [
        "Lead engineering efforts for cross-functional team, from planning through delivery of full-stack solutions.",
        "Develop containerized backend systems using NestJS and Python, applying CQRS to boost modularity and scalability by 40%.",
        "Write secure GraphQL operations using CASL-based RBAC and managed auth with Ory Kratos and Oathkeeper.",
        "Integrate GenAI, LLMs, and BullMQ for dynamic PDF generation and high-volume batch processing, reducing search latency by 70%.",
        "Built FastAPI microservice to process medical PDFs, communicating with Node.js backend via gRPC, improving processing time by 60%.",
        "Integrate AWS Bedrock for AI-driven content generation, accelerating content workflows by 50%.",
        "Design scalable PostgreSQL schemas and TypeORM migrations, maintaining 99.99% DB uptime and optimal query performance.",
        "Manage cloud infrastructure (ECS, ECR, S3, CloudFront, Aurora) ensuring system scalability and 24/7 availability.",
        "Collaborate with stakeholders to refine business requirements and align them with technical solutions.",
        "Establish CI/CD pipelines with GitHub Actions, reducing deployment time by 50% and cutting production bugs by 40%.",
        "Drive TDD adoption maintaining over 90% test coverage in critical backend modules.",
        "Mentor engineers and enforce code quality through reviews and coaching."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Emumba",
      companylogo: require("./assets/images/emumbaLogoWhite.png"),
      date: "July 2020 – June 2023",
      descBullets: [
        "Architected and delivered microservices using NestJS and Python, reducing deployment complexity by 40%.",
        "Built full-stack features using React and NestJS, optimizing performance and user experience.",
        "Designed and maintained RESTful and GraphQL APIs with 35% improvement in response times.",
        "Achieved GDPR compliance for 10K+ users through secure, end-to-end data encryption.",
        "Integrated AWS services (S3, SQS, SES) and automated CI/CD pipelines, cutting deployment time by 80%.",
        "Estimated epics, delegated tasks, and participated in agile ceremonies using Scrum.",
        "Reduced server load by 25% through caching strategies improving API response times by 40%.",
        "Mentored junior developers and participated in architectural decision-making."
      ]
    },
    {
      role: "Software Engineer",
      company: "Emumba",
      companylogo: require("./assets/images/emumbaLogoWhite.png"),
      date: "July 2018 – June 2020",
      descBullets: [
        "Developed scalable backend services in Node.js and NestJS, handling over 500K API requests/day.",
        "Built reusable UI components in React to improve frontend maintainability and performance.",
        "Improved processing time by 80% through Web Worker and async optimization techniques.",
        "Configured CI/CD pipelines in Azure DevOps and integrated unit tests to streamline and automate releases.",
        "Used Docker for containerized deployments, improving scalability and reducing infra costs by 20%.",
        "Maintained API documentation with Swagger and Postman to support partner integrations."
      ]
    },
    {
      role: "Web Developer",
      company: "Digihawks",
      companylogo: require("./assets/images/digihawksLogo.jpeg"),
      date: "September 2017 – February 2018",
      descBullets: [
        "Built a real-time social media marketing platform using Node.js and Angular, enabling engagement tracking for 1K+ campaigns.",
        "Integrated Google Cloud services and Firebase analytics for data processing and live analytics.",
        "Implemented real-time data synchronization and push notification capabilities.",
        "Developed responsive frontend interfaces with modern web design principles."
      ]
    },
    {
      role: "Software Developer",
      company: "IEEE Student Branch",
      companylogo: require("./assets/images/ieeeLogo.png"),
      date: "June 2016 – September 2016",
      descBullets: [
        "Developed a backend monitoring service in .NET and C# to track application uptime and performance.",
        "Implemented an automated alerting system to notify users of service outages via email.",
        "Built monitoring dashboards and reporting tools for system administration.",
        "Gained experience in system monitoring, alerting, and .NET framework development."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Standout Performer",
      subtitle:
        "Awarded and recognized as a Standout Performer by Emumba for consistently delivering high-quality work and exceeding expectations.",
      image: require("./assets/images/emumbaLogoWhite.png"),
      imageAlt: "Standout Performer Award",
      footerLink: [
       
      ]
    },
    {
      title: "Emerging Leader",
      subtitle:
        "Recognized and awarded as the Emerging Leader for demonstrating outstanding leadership potential and mentoring capabilities.",
      image: require("./assets/images/emumbaLogoWhite.png"),
      imageAlt: "Emerging Leader Award",
      footerLink: [
      
      ]
    },
    {
      title: "High Flyer Award 2022-23",
      subtitle:
        "Won the High Flyer award and became part of the Emumba Dream Team 2022-23, recognizing exceptional performance and leadership.",
      image: require("./assets/images/emumbaLogoWhite.png"),
      imageAlt: "High Flyer Award",
      footerLink: [
      
      ]
    },
    {
      title: "Rector Honor List",
      subtitle:
        "Member of Rector Honor List at Bahria University for maintaining excellent academic performance throughout the degree.",
      image: require("./assets/images/bahriaLogo2.png"),
      imageAlt: "Rector Honor List",
      footerLink: [
       
      ]
    },
    {
      title: "Open House Award Winner 2017",
      subtitle:
        "Winner of Open House 2017 award at Bahria University for outstanding final year project presentation and innovation.",
      image: require("./assets/images/bahriaLogo2.png"),
      imageAlt: "Open House Award",
      footerLink: [
       
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-336-5526722",
  email_address: "muhammadusman01501@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
